module.exports = __webpack_public_path__ + "static/media/arrangements.b609a64a.png";